export const USER_TOKEN_KEY = 'user-token';

export const DEBOUNCE_MILLISECONDS = 500;
